import { AchievementTO } from "./AchievementTO";
import { LinkTO } from "./LinkTO";
import { PreferenciasTO } from "./PreferenciasTO";
import { PurchasedPlanDTO } from "./PurchasedPlanDTO";
import { UserDocumentTO } from "./UserDocumentTO";
import { UsuarioBaseTO } from "./UsuarioBaseTO";

export class UsuarioTO extends UsuarioBaseTO {
    id?: string;
    urlAvatar?: string;
    urlBanner?: string;
    userId?: string;
    criadoEm?: Date;
    atualizadoEm?: Date;
    preferencias?: PreferenciasTO;
    links?: LinkTO[];
    idiomas?: string[];
    apresentacao?: string;
    documents?: Array<UserDocumentTO>;
    achievements?: Array<AchievementTO>;
    purchasedPlans?: Array<PurchasedPlanDTO>;
    active: boolean;
    fullName: string;
}
